// extracted by mini-css-extract-plugin
export default {"iconAddImage":"IconAddImage_iconAddImage__Ubdib"};